/* global modForm Modalytics */
import {
	populateFormWithZipData,
	populateLocationFieldsDynamically
} from '../../../helpers';
import { isZipCodeValid } from '../../../validators';
/**
 * Track first zip change and validate on the go
 * @returns {boolean} - false if no zipField is found
 */
export function initTrackZipChange() {
	if (!modForm.opts.zipField.length) {
		return false;
	}

	let isValidating = false;
	let previousZip;
	let zipInputs = modForm.opts.zipField;
	const syncZipForms = modForm.opts.zipFormSelectorsToSync.length;

	if (syncZipForms) {
		zipInputs = [];
		const mainFormZip = modForm.opts.form.querySelector('input[name="zip"]');
		if (mainFormZip) {
			zipInputs.push(mainFormZip);
		}
		modForm.opts.zipFormSelectorsToSync.forEach(function(zipFormId) {
			zipInputs.push(document.querySelector(`${zipFormId} input[name="zip"]`));
		});
	}

	zipInputs.forEach(function(zipField) {
		zipField.addEventListener('keyup', function(e) {
			const $input = this;
			const shouldValidateZip = this.value.length === 5 && !isValidating && e.key !== 'Enter' && this.value !== previousZip;

			if (shouldValidateZip) {
				previousZip = this.value;
				if (syncZipForms) {
					zipInputs.forEach((zipInput) => {
						zipInput.value = $input.value;
					});
				}

				isValidating = true;
				isZipCodeValid($input.value, function(response) {
					isValidating = false;
					if (response.success) {
						if (response.data) {
							populateFormWithZipData(response.data);
							populateLocationFieldsDynamically(response.data);
						}

						if (syncZipForms) {
							zipInputs.forEach((zipInput) => {
								zipInput.closest('.form-group').classList.remove(modForm.opts.fieldErrorCls);
							});
						} else {
							$input.closest('.form-group').classList.remove(modForm.opts.fieldErrorCls);
						}
						modForm.opts.zipCode = response.data.zip;
						// Fire callback
						if ('function' === typeof modForm.opts.zipCodeValidated) {
							modForm.opts.zipCodeValidated(response.data);
						}
					} else {
						if (syncZipForms) {
							zipInputs.forEach((zipInput) => {
								zipInput.closest('.form-group').classList.add(modForm.opts.fieldErrorCls);
							});
						} else {
							$input.closest('.form-group').classList.add(modForm.opts.fieldErrorCls);
						}
					}

					if ($input.getAttribute('data-geolocation-loaded') === 'true' && !$input.hasAttribute('data-geo-zip-overridden')) {
						const source = window.geolocation?.source;
						const formattedSource = source ? source.charAt(0).toUpperCase() + source.slice(1) : '';
						Modalytics.heap('track', ['ChangeZip', {
							geoAPIGroup: formattedSource
						}]);
						$input.setAttribute('data-geo-zip-overridden', 'true');
					}
				}, true, function() {
					isValidating = false;
				});
			}
		});
	});
}
